import React from "react";
import { Badge } from "@mantine/core";

export const tagBadgeColor = (name, type = 0) => {
  if (isGlobalManualTag(name)) {
    switch (name) {
      case "like":
        return "red";
      case "veryGood":
        return "orange";
      case "good":
        return "green";
      case "inProgress":
        return "cyan";
      case "todo":
        return "blue";
      case "finished":
        return "yellow";
      case "bad":
        return "gray";
      case "noRating":
        return "pink";
    }
  }

  if (isGlobalAutomaticTag(name)) {
    return "teal";
  }

  if (type == 5) {
    return "indigo";
  }

  if (type == 6) { // subCategory (movie / series)
    return "grape";
  }

  if (type == 7) { // year-range bucket
    return "lime";
  }

  return "gray";
};

export const tagName = (name, language, artCategory) => {
  // The noRating label bends on context — art page callers pass an
  // artCategory so the label reads "watched but no rating yet" (or
  // read/played) per the medium. Callers without a category (list
  // views like PersonalArtEvents) get the generic short form.
  if (name === "noRating") {
    if (artCategory) {
      const en = artCategory === 1 ? "watched"
        : artCategory === 2 ? "played"
          : artCategory === 3 ? "read"
            : "seen";
      const ru = artCategory === 1 ? "смотрел"
        : artCategory === 2 ? "играл"
          : artCategory === 3 ? "читал"
            : "видел";
      return language === "ru"
        ? `🌸 ${ru}, но пока без оценки`
        : `🌸 ${en} but no rating yet`;
    }
    return language === "ru" ? "🌸 пока без оценки" : "🌸 no rating yet";
  }

  const mapping = {
    en: {
      like:      "❤️ favorite",
      veryGood:  "⭐ very good",
      good:      "⭐ good",
      inProgress:"⏳ in progress",
      todo:      "📌 todo",
      finished:  "⚪ neutral",
      bad:       "👎 bad",

      book: "📖 book",
      movie: "🎥 movie",
      game: "🎮 game",
      youtubechannel: "youtube",

      film: "film",
      series: "series"
    },

    ru: {
      like:      "❤️ любимое",
      veryGood:  "⭐ очень понравилось",
      good:      "⭐ понравилось",
      inProgress:"⏳ в процессе",
      todo:      "📌 планы",
      finished:  "⚪ нейтрально",
      bad:       "👎 не понравилось",

      book: "📖 книга",
      movie: "🎥 фильм",
      game: "🎮 игра",
      youtubechannel: "youtube",

      film: "полнометражка",
      series: "сериал"
    }
  };

  const val = mapping[language][name];
  return val === undefined ? "#"+name : val;
};

const baseStyles = {
  root: {
    paddingInline: 14,
    paddingBlock: 7,
    height: "auto",
    display: "inline-flex",
    alignItems: "center"
  },
  label: {
    textTransform: "none",
    fontSize: 14,
    lineHeight: 1.2,
    display: "inline-flex",
    alignItems: "center",
    color: "white"
  }
};

const mergeStyles = (styles) => {
  if (!styles) {
    return baseStyles;
  }
  return {
    ...styles,
    root: { ...baseStyles.root, ...(styles.root || {}) },
    label: { ...baseStyles.label, ...(styles.label || {}) }
  };
};

const TagBadge = React.forwardRef(({ styles, ...props }, ref) => {
  return <Badge ref={ref} styles={mergeStyles(styles)} {...props} />;
});

const isGlobalManualTag = (name) => {
  return ["like", "todo", "finished", "veryGood", "good", "bad", "inProgress", "noRating"].includes(name);
};

const isGlobalAutomaticTag = (name) => {
  if (name === "book" || name === "movie" || name === "game" || name === "youtubechannel") {
    return true;
  }
  return false;
};

export default TagBadge;
